var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 10.707C14.8002 10.6143 14.8741 10.5042 14.9246 10.3829C14.9751 10.2615 15.001 10.1314 15.001 10C15.001 9.86859 14.9751 9.73848 14.9246 9.61715C14.8741 9.49581 14.8002 9.38565 14.707 9.293L10.464 5.05C10.2754 4.86784 10.0228 4.76705 9.7606 4.76933C9.4984 4.7716 9.24759 4.87677 9.06218 5.06218C8.87677 5.24759 8.7716 5.4984 8.76933 5.7606C8.76705 6.0228 8.86784 6.2754 9.05 6.464L11.586 9H6C5.73478 9 5.48043 9.10536 5.29289 9.29289C5.10536 9.48043 5 9.73478 5 10C5 10.2652 5.10536 10.5196 5.29289 10.7071C5.48043 10.8946 5.73478 11 6 11H11.586L9.05 13.536C8.86784 13.7246 8.76705 13.9772 8.76933 14.2394C8.7716 14.5016 8.87677 14.7524 9.06218 14.9378C9.24759 15.1232 9.4984 15.2284 9.7606 15.2307C10.0228 15.233 10.2754 15.1322 10.464 14.95L14.707 10.707ZM4 0H16C17.0609 0 18.0783 0.421427 18.8284 1.17157C19.5786 1.92172 20 2.93913 20 4V16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20H4C2.93913 20 1.92172 19.5786 1.17157 18.8284C0.421427 18.0783 0 17.0609 0 16V4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0Z",
    fill: "#3397F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.9fa6ca296166bf24be66d1c499cfe038.svg";
export { ForwardRef as ReactComponent };